/* Marlow Header JS - Sticky scroll + Mobile menu + Accordions */

(function() {
  const header = document.querySelector('.marlow-header');
  
  // Mobile toggle - wire up regardless of transparent mode
  const toggle = document.querySelector('.marlow-header__mobile-toggle');
  const mobileMenu = document.querySelector('.marlow-header__mobile-menu');
  
  if (toggle && mobileMenu) {
    // Main menu open/close
    toggle.addEventListener('click', function() {
      const isOpen = mobileMenu.getAttribute('aria-hidden') === 'false';
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      
      // Always reset body overflow explicitly
      if (isOpen) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.documentElement.style.overflow = '';
      } else {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.documentElement.style.overflow = 'hidden';
      }
      
      // Reset all submenus when closing
      if (isOpen) {
        document.querySelectorAll('.marlow-header__mobile-submenu[aria-hidden="false"]').forEach(function(sub) {
          sub.setAttribute('aria-hidden', 'true');
        });
        document.querySelectorAll('.marlow-header__mobile-subsubmenu[aria-hidden="false"]').forEach(function(sub) {
          sub.setAttribute('aria-hidden', 'true');
        });
        document.querySelectorAll('.marlow-header__mobile-link--toggle[aria-expanded="true"]').forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.marlow-header__mobile-sublink--toggle[aria-expanded="true"]').forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
    
    // Level 1 accordion - top level items with children
    document.querySelectorAll('.marlow-header__mobile-link--toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        
        const submenu = this.nextElementSibling;
        if (submenu && submenu.classList.contains('marlow-header__mobile-submenu')) {
          submenu.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
        }
      });
    });
    
    // Level 2 accordion - sub items with children
    document.querySelectorAll('.marlow-header__mobile-sublink--toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        
        const subsubmenu = this.nextElementSibling;
        if (subsubmenu && subsubmenu.classList.contains('marlow-header__mobile-subsubmenu')) {
          subsubmenu.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
        }
      });
    });
  }
  
  // Sticky scroll detection - only for transparent headers
  if (!header) return;
  const isTransparent = header.classList.contains('marlow-header--transparent');
  if (!isTransparent) return;
  
  let ticking = false;
  
  function updateHeader() {
    const scrolled = window.scrollY > 50;
    header.classList.toggle('is-scrolled', scrolled);
    ticking = false;
  }
  
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
  
  updateHeader();
})();
